/**
 * Auth Modal — Login / Registrierung
 *
 * Login:        AJAX → Pimcore POST /api/b2b/login (Shopify Storefront API proxy)
 * Recovery:     AJAX → Pimcore POST /api/b2b/recover
 * Registration: AJAX → Pimcore POST /api/b2b/register
 *
 * Session stored in localStorage key "b2b_session" as JSON.
 */
(function () {
  'use strict';

  var API_BASE = (window.b2bConfig && window.b2bConfig.apiBase) || 'https://pim.schaltschrank24.ch';

  /**
   * Seitensprache fuer die /api/b2b/*-Aufrufe. Quelle ist b2bConfig.locale
   * (aus request.locale.iso_code, siehe layout/theme.liquid); <html lang> und
   * zuletzt 'de' sind nur Rueckfaelle, falls das Snippet mal nicht laeuft.
   */
  function b2bLocale() {
    return (window.b2bConfig && window.b2bConfig.locale)
        || document.documentElement.getAttribute('lang')
        || 'de';
  }

  // ── DOM refs ─────────────────────────────────────────────────────────────
  var modal, overlay, closeBtn, tabs, loginPanel, recoverPanel, registerPanel;
  var loginForm, loginSubmit, loginMessage;
  var recoverForm, recoverSubmit, recoverMessage;
  var registerForm, registerSubmit, registerMessage;
  var privateCheckbox, firmaWrap, firmaInput, uidWrap, uidInput, uidError;
  var rechnungWrap, rechnungInput, abWrap, abInput;

  // ── Init ─────────────────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    modal = document.getElementById('AuthModal');
    if (!modal) return;

    overlay       = document.getElementById('AuthModal-Overlay');
    closeBtn      = modal.querySelector('.auth-modal__close');
    tabs          = modal.querySelectorAll('.auth-modal__tab');
    loginPanel    = document.getElementById('auth-panel-login');
    recoverPanel  = document.getElementById('auth-panel-recover');
    registerPanel = document.getElementById('auth-panel-register');

    loginForm     = document.getElementById('auth-modal-login-form');
    loginSubmit   = document.getElementById('auth-login-submit');
    loginMessage  = document.getElementById('auth-login-message');

    recoverForm    = document.getElementById('auth-modal-recover-form');
    recoverSubmit  = document.getElementById('auth-recover-submit');
    recoverMessage = document.getElementById('auth-recover-message');

    registerForm    = document.getElementById('b2b-register-form-modal');
    registerSubmit  = document.getElementById('b2b-modal-submit');
    registerMessage = document.getElementById('auth-register-message');

    privateCheckbox = document.getElementById('modal-is-private');
    firmaWrap  = document.getElementById('modal-firma-wrap');
    firmaInput = document.getElementById('modal-firma');
    uidWrap    = document.getElementById('modal-uid-wrap');
    uidInput   = document.getElementById('modal-uid');
    uidError   = document.getElementById('modal-uid-error');
    rechnungWrap  = document.getElementById('modal-rechnung-email-wrap');
    rechnungInput = document.getElementById('modal-rechnung-email');
    abWrap        = document.getElementById('modal-ab-email-wrap');
    abInput       = document.getElementById('modal-ab-email');

    // Trigger button (account icon)
    // If a valid B2B session exists, redirect to /pages/konto instead of opening modal
    var trigger = document.getElementById('auth-modal-trigger');
    if (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (loadB2bSession()) {
          window.location.href = window.localizeUrl('/pages/konto');
        } else {
          openModal('login');
        }
      });
    }

    // Mobile drawer account link
    var drawerLink = document.getElementById('drawer-account-link');
    if (drawerLink && loadB2bSession()) {
      drawerLink.href = window.localizeUrl('/pages/konto');
    }

    // Header-Label an den localStorage-Login angleichen: der serverseitige
    // {% if customer %}-Zweig kennt die custom-B2B-Session nicht (kein nativer
    // Shopify-customer) → Button zeigt sonst dauerhaft "Einloggen", obwohl
    // eingeloggt. Hier clientseitig auf "Mein Konto"/Vorname umstellen.
    reflectLoginInHeader();

    // Close
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (overlay)  overlay.addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('active')) closeModal();
    });

    // Tabs
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { switchTab(tab.getAttribute('data-tab')); });
    });

    // Panel switching
    var backBtn   = recoverPanel  && recoverPanel.querySelector('[data-action="show-login"]');
    var forgotBtn = loginPanel    && loginPanel.querySelector('[data-action="show-recover"]');
    if (backBtn)   backBtn.addEventListener('click', showLoginPanel);
    if (forgotBtn) forgotBtn.addEventListener('click', showRecoverPanel);

    modal.querySelectorAll('[data-action="switch-tab"]').forEach(function (btn) {
      btn.addEventListener('click', function () { switchTab(btn.getAttribute('data-tab')); });
    });

    // Forms
    if (loginForm)    loginForm.addEventListener('submit', handleLogin);
    if (recoverForm)  recoverForm.addEventListener('submit', handleRecover);
    if (registerForm) {
      registerForm.addEventListener('submit', handleRegister);
      if (privateCheckbox) privateCheckbox.addEventListener('change', togglePrivateMode);
      if (uidInput)         uidInput.addEventListener('blur', checkUidDuplicate);
    }

    // Auto-open
    var hash   = window.location.hash;
    var params = new URLSearchParams(window.location.search);
    if (hash === '#register' || params.get('tab') === 'register') openModal('register');
    if (hash === '#login'    || params.get('openModal') === 'login') openModal('login');

    // Triggered by checkout-gate.js "Passwort vergessen?" link
    window.addEventListener('auth:openRecover', function () {
      openModal('login');
      showRecoverPanel();
    });
  });

  // ── Open / Close ─────────────────────────────────────────────────────────
  function openModal(tab) {
    modal.classList.add('active');
    document.body.classList.add('overflow-hidden');
    switchTab(tab || 'login');
    setTimeout(function () {
      var first = modal.querySelector('.auth-modal__panel:not([hidden]) input:not([disabled])');
      if (first) first.focus();
    }, 100);
  }

  function closeModal() {
    modal.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }

  // ── Tab / Panel switching ────────────────────────────────────────────────
  function switchTab(tabName) {
    tabs.forEach(function (t) {
      var active = t.getAttribute('data-tab') === tabName;
      t.classList.toggle('auth-modal__tab--active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    [loginPanel, recoverPanel, registerPanel].forEach(function (p) {
      if (p) p.hidden = (p.getAttribute('data-panel') !== tabName);
    });
    if (tabName === 'login' && recoverPanel && !recoverPanel.hidden) {
      recoverPanel.hidden = true;
      loginPanel.hidden   = false;
    }
  }

  function showLoginPanel() {
    if (!loginPanel || !recoverPanel) return;
    recoverPanel.hidden = true;
    loginPanel.hidden   = false;
    tabs.forEach(function (t) {
      var active = t.getAttribute('data-tab') === 'login';
      t.classList.toggle('auth-modal__tab--active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }

  function showRecoverPanel() {
    if (!loginPanel || !recoverPanel) return;
    loginPanel.hidden   = true;
    recoverPanel.hidden = false;
  }

  // ── Message helpers ──────────────────────────────────────────────────────
  function showMsg(el, text, type) {
    if (!el) return;
    el.textContent = text;
    el.className = 'auth-modal__message auth-modal__message--' + (type === 'success' ? 'success' : 'error');
    el.hidden = false;
    el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
  function hideMsg(el) { if (el) { el.hidden = true; el.textContent = ''; } }

  // Firma bereits registriert (409 + code=company_already_registered):
  // Meldung + CTA "Einladungslink anfordern" statt reinem Fehler. createElement
  // (kein innerHTML → XSS-sicher); Button erbt die Designklasse des Submit-Buttons.
  function showRegisterCTA(payload) {
    var el = registerMessage;
    if (!el) return;
    el.textContent = '';
    el.className = 'auth-modal__message auth-modal__message--error';
    el.hidden = false;

    var p = document.createElement('p');
    p.style.margin = '0 0 .8rem';
    p.textContent = window.customStrings.inviteFirmExists;
    el.appendChild(p);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = (registerSubmit && registerSubmit.className) || 'auth-modal__submit';
    btn.textContent = window.customStrings.inviteRequestBtn;
    el.appendChild(btn);

    btn.addEventListener('click', function () {
      btn.disabled = true;
      btn.textContent = window.customStrings.sending;
      fetch(API_BASE + '/api/b2b/request-invitation', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          firma:   payload.firma,
          uid:     payload.uid,
          email:   payload.email,
          name:    ((payload.vorname || '') + ' ' + (payload.nachname || '')).trim(),
          telefon: payload.telefon,
        }),
      })
        .then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (data) {
          el.textContent = '';
          el.className = 'auth-modal__message auth-modal__message--success';
          var done = document.createElement('p');
          done.style.margin = '0';
          done.textContent = (data && data.message)
            || window.customStrings.inviteThanks;
          el.appendChild(done);
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = window.customStrings.inviteRequestBtn;
        });
    });

    el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  // ── AJAX Login ───────────────────────────────────────────────────────────
  function handleLogin(e) {
    e.preventDefault();
    hideMsg(loginMessage);

    var emailEl    = loginForm.querySelector('[name="email"]');
    var passwordEl = loginForm.querySelector('[name="password"]');

    if (!emailEl || !emailEl.value.trim()) {
      showMsg(loginMessage, window.customStrings.enterEmail, 'error');
      if (emailEl) emailEl.focus();
      return;
    }
    if (!passwordEl || !passwordEl.value) {
      showMsg(loginMessage, window.customStrings.enterPassword, 'error');
      if (passwordEl) passwordEl.focus();
      return;
    }

    loginSubmit.disabled    = true;
    loginSubmit.textContent = window.customStrings.signingIn;

    fetch(API_BASE + '/api/b2b/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email:    emailEl.value.trim(),
        password: passwordEl.value,
        locale:   b2bLocale(),
      }),
    })
      .then(function (r) { return r.json().then(function (d) { return { status: r.status, data: d }; }); })
      .then(function (res) {
        if (res.status === 200 && res.data.success) {
          // Save session to localStorage
          try { localStorage.setItem('b2b_session', JSON.stringify(res.data.session)); } catch (e) {}
          // B2B-Preis-Cache eines evtl. vorherigen Nutzers (geteiltes Gerät) verwerfen.
          if (window.B2BPriceCache) window.B2BPriceCache.clearAll();
          window.location.href = window.localizeUrl('/pages/konto');
        } else {
          showMsg(loginMessage, res.data.error || window.customStrings.loginFailed, 'error');
          loginSubmit.disabled    = false;
          loginSubmit.textContent = window.customStrings.login;
        }
      })
      .catch(function () {
        showMsg(loginMessage, window.customStrings.net1, 'error');
        loginSubmit.disabled    = false;
        loginSubmit.textContent = window.customStrings.login;
      });
  }

  // ── AJAX Password Recovery ───────────────────────────────────────────────
  function handleRecover(e) {
    e.preventDefault();
    hideMsg(recoverMessage);

    var emailInput = recoverForm.querySelector('[name="email"]');
    if (!emailInput || !emailInput.value.trim()) {
      showMsg(recoverMessage, window.customStrings.enterEmail, 'error');
      if (emailInput) emailInput.focus();
      return;
    }

    recoverSubmit.disabled    = true;
    recoverSubmit.textContent = window.customStrings.sending;

    fetch(API_BASE + '/api/b2b/recover', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: emailInput.value.trim(), locale: b2bLocale() }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        showMsg(
          recoverMessage,
          window.customStrings.resetSent || data.message,
          'success'
        );
        recoverSubmit.disabled    = false;
        recoverSubmit.textContent = window.customStrings.requestReset;
        emailInput.value = '';
      })
      .catch(function () {
        showMsg(recoverMessage, window.customStrings.net1, 'error');
        recoverSubmit.disabled    = false;
        recoverSubmit.textContent = window.customStrings.requestReset;
      });
  }

  // ── Privatperson Toggle ──────────────────────────────────────────────────
  function togglePrivateMode() {
    var isPrivate = privateCheckbox.checked;
    setFieldDisabled(firmaWrap, firmaInput, isPrivate);
    setFieldDisabled(uidWrap,   uidInput,   isPrivate);
    // Optional B2B-only billing/order-confirmation emails — never required.
    setOptionalFieldDisabled(rechnungWrap, rechnungInput, isPrivate);
    setOptionalFieldDisabled(abWrap,       abInput,       isPrivate);
    // Firmen-Hinweis im Benefits-Text ausblenden, wenn Privatperson.
    var benefit = document.getElementById('modal-benefit-verify');
    if (benefit) benefit.style.display = isPrivate ? 'none' : '';
    if (isPrivate) setUidError('');
  }

  function setFieldDisabled(wrapper, input, disabled) {
    if (!input) return;
    input.disabled = disabled;
    input.required = !disabled;
    if (wrapper) wrapper.style.display = disabled ? 'none' : '';
  }

  // Same as setFieldDisabled but never toggles `required` — for optional fields.
  function setOptionalFieldDisabled(wrapper, input, disabled) {
    if (!input) return;
    input.disabled = disabled;
    if (wrapper) wrapper.style.display = disabled ? 'none' : '';
  }

  // ── UID duplicate check ──────────────────────────────────────────────────
  function checkUidDuplicate() {
    if (!uidInput) return;
    var uid = uidInput.value.trim();
    if (!uid || (privateCheckbox && privateCheckbox.checked)) return;
    var emailEl = registerForm && registerForm.querySelector('[name="email"]');
    var email   = emailEl ? emailEl.value.trim() : '';
    var url     = API_BASE + '/api/b2b/check-uid?uid=' + encodeURIComponent(uid)
                + (email ? '&email=' + encodeURIComponent(email) : '');
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        setUidError(data.exists && !data.stub
          ? window.customStrings.uidExists
          : '');
      })
      .catch(function () {});
  }

  function setUidError(msg) {
    if (!uidError) return;
    uidError.textContent = msg || '';
    uidError.hidden = !msg;
  }

  // ── AJAX Registration ────────────────────────────────────────────────────
  function handleRegister(e) {
    e.preventDefault();
    hideMsg(registerMessage);

    var isPrivate = privateCheckbox ? privateCheckbox.checked : false;

    var required = ['vorname', 'nachname', 'email', 'passwort', 'passwort2', 'telefon', 'strasse', 'plz', 'ort', 'land'];
    if (!isPrivate) required = ['firma', 'uid'].concat(required);

    for (var i = 0; i < required.length; i++) {
      var name  = required[i];
      var field = registerForm.querySelector('[name="' + name + '"]');
      if (!field || !field.value.trim()) {
        showMsg(registerMessage, window.customStrings.fillRequired, 'error');
        if (field) field.focus();
        return;
      }
    }

    // Email format
    var emailVal = registerForm.querySelector('[name="email"]').value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal)) {
      showMsg(registerMessage, window.customStrings.validEmail, 'error');
      return;
    }

    // Password length
    var pwVal  = registerForm.querySelector('[name="passwort"]').value;
    var pw2Val = registerForm.querySelector('[name="passwort2"]').value;
    if (pwVal.length < 8) {
      showMsg(registerMessage, window.customStrings.pwMin8, 'error');
      return;
    }
    if (pwVal !== pw2Val) {
      showMsg(registerMessage, window.customStrings.pwMismatch, 'error');
      return;
    }

    // Block on UID error
    if (uidError && !uidError.hidden && uidError.textContent) {
      showMsg(registerMessage, uidError.textContent, 'error');
      return;
    }

    registerSubmit.disabled    = true;
    registerSubmit.textContent = window.customStrings.sending;

    // Build payload
    var payload = { is_private: isPrivate };
    var allFields = ['firma', 'rechnung_email', 'auftragsbestaetigung_email', 'uid', 'vorname', 'nachname', 'email', 'passwort', 'passwort2',
                     'telefon', 'strasse', 'hausnummer', 'plz', 'ort', 'land'];
    allFields.forEach(function (name) {
      var f = registerForm.querySelector('[name="' + name + '"]');
      payload[name] = f ? f.value.trim() : '';
    });
    var newsletterEl = document.getElementById('modal-newsletter');
    payload.newsletter = newsletterEl ? newsletterEl.checked : true;

    fetch(API_BASE + '/api/b2b/register', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(Object.assign({ locale: b2bLocale() }, payload)),
    })
      .then(function (r) { return r.json().then(function (d) { return { status: r.status, data: d }; }); })
      .then(function (res) {
        if (res.status === 201) {
          // GA4/LinkedIn 2026-08-26: Registrierung erfolgreich. In try/catch — ein
          // Trackingfehler darf nie eine Registrierung kosten.
          try { (window.dataLayer = window.dataLayer || []).push({ event: 'sign_up', method: 'b2b_registration' }); } catch (e) {}
          registerForm.style.display = 'none';
          showMsg(
            registerMessage,
            (res.data.message || window.customStrings.accountCreated) + window.customStrings.canLoginNow,
            'success'
          );
          // Switch to login tab after 2 seconds
          setTimeout(function () { switchTab('login'); registerForm.style.display = ''; }, 2500);
        } else if (res.status === 409) {
          if (res.data && res.data.code === 'company_already_registered') {
            showRegisterCTA(payload);
          } else {
            showMsg(registerMessage, res.data.error || window.customStrings.accountExistsUid, 'error');
          }
          registerSubmit.disabled    = false;
          registerSubmit.textContent = window.customStrings.createAccount;
        } else {
          showMsg(registerMessage, res.data.error || window.customStrings.registerFailed, 'error');
          registerSubmit.disabled    = false;
          registerSubmit.textContent = window.customStrings.createAccount;
        }
      })
      .catch(function () {
        showMsg(registerMessage, window.customStrings.net1, 'error');
        registerSubmit.disabled    = false;
        registerSubmit.textContent = window.customStrings.createAccount;
      });
  }

  // ── Header-Label nach Login ────────────────────────────────────────────────
  // Spiegelt die localStorage-Session in den Header-Account-Button (und die
  // Mobile-Drawer-Zeile), da der serverseitige customer-Zweig die custom-Session
  // nicht kennt. Idempotent, fehlertolerant.
  function reflectLoginInHeader() {
    try {
      var s = loadB2bSession();
      if (!s) return;
      var first = (s.firstName || '').trim();
      var label = first ? first : window.customStrings.myAccount;
      var safe  = label.replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
      var trg = document.getElementById('auth-modal-trigger');
      if (trg) {
        var at = trg.querySelector('.account-text');
        if (at) at.innerHTML = '<span class="visually-hiddenn">' + safe + '</span>';
        trg.setAttribute('aria-label', label + ' – ' + window.customStrings.myAccount);
        trg.setAttribute('title', label + ' – ' + window.customStrings.myAccount);
      }
    } catch (e) {}
  }

  // ── Session helper ───────────────────────────────────────────────────────
  function loadB2bSession() {
    try {
      var raw = localStorage.getItem('b2b_session');
      if (!raw) return null;
      var s = JSON.parse(raw);
      if (s.expiresAt && new Date(s.expiresAt) < new Date()) {
        localStorage.removeItem('b2b_session');
        if (window.B2BPriceCache) window.B2BPriceCache.clearAll();
        return null;
      }
      return s;
    } catch (e) { return null; }
  }
})();
